/**
 * dateUtils.ts — Utility functions for date formatting.
 */

import type { FullProjectContentBlock } from "./types.js";

/**
 * Mapping of month numbers (1-12) to short month names as specified by user.
 */
const MONTH_MAP: Record<number, string> = {
    1: "Jan.",
    2: "Feb.",
    3: "Mar.",
    4: "Apr.",
    5: "May",
    6: "June",
    7: "July",
    8: "Aug.",
    9: "Sep.",
    10: "Okt.",
    11: "Nov.",
    12: "Dec.",
};

/**
 * Formats a project's start and end dates into a string like "Nov. 2024 - Feb. 2026".
 * 
 * @param start The start month and year.
 * @param end The end month and year.
 * @returns Formatted duration string.
 */
export function formatProjectDuration(
    start: FullProjectContentBlock["start"],
    end: FullProjectContentBlock["end"]
): string {
    const startMonth = MONTH_MAP[start.month] || start.month.toString();
    const endMonth = MONTH_MAP[end.month] || end.month.toString();
    
    return `${startMonth} ${start.year} - ${endMonth} ${end.year}`;
}
